import { render, staticRenderFns } from "./PracticeAddModal.vue?vue&type=template&id=1f3fe8fe&"
import script from "./PracticeAddModal.vue?vue&type=script&lang=js&"
export * from "./PracticeAddModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports